import { gql } from "@apollo/client";
import { ButtonBase, Paper } from "@mui/material";
import VideoThumbnail from "atoms/VideoThumbnail";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import { SPACING_DENSE, SPACING_DENSE_HALF } from "helpers/spacings";
import EventMarker, { EventMarkerFragment } from "molecules/EventMarker";
import EventSubjectLabel, { EventSubjectLabelFragment } from "molecules/EventSubjectLabel";
import ViewCountLabel from "molecules/ViewCountLabel";
import HighlightPlayerDialog from "pages/video_player/HighlightPlayerDialog";
import React, { useState } from "react";

export const EventCardFragment = gql`
  fragment EventCardFragment on Event {
    id
    thumbnailUrl
    videoUrl
    videoPending
    viewCount
    ...EventMarkerFragment
    ...EventSubjectLabelFragment
  }
  ${EventMarkerFragment}
  ${EventSubjectLabelFragment}
`;

const textStyle = {
  fontSize: 12,
  maxWidth: "100%",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
};

export default function EventCard({ event }) {
  const [dialogOpen, dialogOpenSet] = useState(false);
  const playerNumber = event.gamePlayer?.playerNumber;

  return (
    <div style={{ display: "flex", flexFlow: "column nowrap", minWidth: 0 }}>
      <HighlightPlayerDialog eventId={event.id} open={dialogOpen} onClose={() => dialogOpenSet(false)} />
      <ButtonBase
        component={ButtonBase}
        href={`/event/${event.id}`}
        onClick={(event) => {
          if (event.ctrlKey || event.shiftKey || event.metaKey || event.altKey) return;
          event.preventDefault();
          dialogOpenSet(true);
        }}
        style={{
          display: "flex",
          justifyContent: "stretch",
          alignItems: "stretch",
        }}
      >
        <VideoThumbnail
          component={Paper}
          thumbnailUrl={event.thumbnailUrl}
          videoUrl={event.videoUrl}
          processing={event.videoPending}
          style={{ width: "100%", fontFamily: FONT_FAMILY_GRAPHIK, borderRadius: 12 }}
          leftLabel={<EventMarker size={18} event={event} />}
          rightLabel={<ViewCountLabel viewCount={event.viewCount} />}
        />
      </ButtonBase>
      <div style={{ padding: `${SPACING_DENSE} 0 0 ${SPACING_DENSE}`, fontFamily: FONT_FAMILY_GRAPHIK }}>
        <div style={{ ...textStyle, fontWeight: 500 }}>
          <EventSubjectLabel event={event} />
          {playerNumber ? ` #${playerNumber}` : ""}
        </div>
        <div style={{ ...textStyle, marginTop: SPACING_DENSE_HALF, color: "rgba(0, 0, 0, 0.54)" }}>
          {event.humanName}
        </div>
      </div>
    </div>
  );
}
